import { useDetermineValueToShow } from "./utils/useDetermineValueToShow";
import "./index.scss";

const DEFAULT_SELLING_RATE = { last_two_days: 0, last_day: 0, last_hour: 0 };

export const SellingRate = ({ sellingRate = DEFAULT_SELLING_RATE }) => {
  const { determineInterval, determineNumberSold } = useDetermineValueToShow();
  const interval = determineInterval(sellingRate);
  const numberSold = determineNumberSold(sellingRate);

  if (!interval) return null;

  return (
    <div className="container" data-testid="selling-rate">
      <p className="text">
        <span className="green-text">{numberSold}</span> Sold in Last {interval}
      </p>
    </div>
  );
};
